<template>
  <div
    id="side-navigation-menu"
    class="side-navigation-menu"
    v-if="isAuthenticated"
  >
    <div
      id="components"
      class="navigation-menu-wrapper animated preFadeInRight fadeInRight"
    >
      <!-- Navigation Header -->
      <div class="navigation-menu-header">
        <span></span>
        <a
          id="side-menu-close"
          class="ml-auto hamburger-btn navigation-close"
          href=""
          @click.prevent="hideSideMenu"
        >
          <span class="menu-toggle">
            <span class="icon-box-toggle" id="icon-box-toggle">
              <span class="rotate">
                <i class="icon-line-top"></i>
                <i class="icon-line-center"></i>
                <i class="icon-line-bottom"></i>
              </span>
            </span>
          </span>
        </a>
      </div>
      <!-- Navigation body -->
      <ul class="navigation-menu">
        <li><router-link :to="{ name: 'Home' }">My Events</router-link></li>
        <li>
          <router-link :to="{ name: 'EditProfile' }">Edit Profile</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'ManageDependants' }"
            >Manage Dependants</router-link
          >
        </li>
        <li>
          <a class="parent-link admin-area" href="/admin-v2">Admin Area</a>
        </li>
        <li>
          <a
            class="parent-link logout"
            href=""
            @click.stop.prevent="logoutClick()"
            >Log out</a
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters(["isAuthenticated"]),
  },
  methods: {
    ...mapActions(["logout"]),
    hideSideMenu() {
      let elements = document.querySelectorAll(
        ".hamburger-btn .icon-box-toggle"
      );
      let element2 = document.getElementById("side-navigation-menu");

      elements.forEach((element) => element.classList.toggle("active"));
      //element1.classList.toggle("active");
      element2.classList.toggle("is-active");
    },
    logoutClick() {
      this.logout();
      window.location = "/";
    },
  },
};
</script>